<script>
    import VcPaginacao from "@/components/Form/Paginacao";

    export default {
        components: {
            VcPaginacao,
        },
        data() {
            return {
                pagination: {},
                filtro: null,
                order: "ASC",
                porPagina: {label: "25", value: "25"},
                enviosEmbrapa: [],
            };
        },

        watch: {
            tipo() {
                this.navigate(1);
            },
            porPagina() {
                this.navigate(1);
            },
            filtro() {
                this.navigate(1);
            }
        },

        computed: {
        },

        methods: {
            navigate(pagina) {
                this.$http.post("api/embrapa/listagem?page=" + pagina, {
                    ordem: this.order,
                    porPg: this.porPagina.value,
                })
                .then(response => {
                    this.$set(this, "enviosEmbrapa", response.data.data);
                    this.$set(this, "pagination", response.data);
                })
            },

            ordenar() {
                if (this.order === "ASC") {
                    this.order = "DESC";
                } else {
                    this.order = "ASC";
                }
                this.navigate(1);
            },

            extrairAmostra(json) {
                let objeto

                if (typeof json === 'string') {
                    try {
                    objeto = JSON.parse(json)
                    } catch (e) {
                    console.error('JSON inválido', e)
                    return []
                    }
                } else {
                    objeto = json
                }

                if (
                    !objeto ||
                    !objeto.amostras ||
                    !Array.isArray(objeto.amostras) ||
                    objeto.amostras.length === 0
                ) {
                    return []
                }

                const amostra = objeto.amostras[0]

                return Object.entries(amostra).map(([chave, valor]) => ({
                    label: this.formatarLabel(chave),
                    valor
                }))
            },
            formatarLabel(chave) {
                return chave
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/^./, l => l.toUpperCase())
            }
        },

        mounted() {
            this.navigate(1);
            this.$store.dispatch("setTitle", "Envios Embrapa");
        }
    };

</script>

<template>
    <div class="margin-top-10">
        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        <label>Registros por página</label>
                        <v-select
                                v-model="porPagina"
                                :options="[
                                {label: '10', value: '10'},
                                {label: '25', value: '25'},
                                {label: '50', value: '50'},
                                {label: '100', value: '100'},
                            ]"
                        ></v-select>
                    </div>
                </div>


                <div class="row">
                    <div class="col-sm-12">
                        <table class="table dataTable">
                            <thead>
                                <tr role="row">
                                    <th width="10%">Analise</th>
                                    <th width="10%" class="clickable" @click="ordenar">Data de envio</th>
                                    <th width="35%">Dados de envio</th>
                                    <th width="35%">Dados retornados</th>
                                    <th width="10%" class="text-center"></th>
                                </tr>
                            </thead>
                            <tbody :key="indexEnvioEmbrapa" v-for="(envioEmbrapa, indexEnvioEmbrapa) in enviosEmbrapa">
                                <tr role="row" class="even">
                                    <td>{{envioEmbrapa.analise.registro}} / {{ envioEmbrapa.analise.ano_registro }}</td>
                                    <td>{{envioEmbrapa.created_at }}</td>
                                    <td class="text-left">
                                        <div
                                            v-for="item in extrairAmostra(envioEmbrapa.request_payload)"
                                            :key="item.label"
                                        >
                                            <strong>{{ item.label }}:</strong> {{ item.valor }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            v-for="item in extrairAmostra(envioEmbrapa.response_payload)"
                                            :key="item.label"
                                        >
                                            <strong>{{ item.label }}:</strong> {{ item.valor }}
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <!-- <button :class="{'btn btn-xs btn-success': envioEmbrapa.enviou, 'btn btn-xs btn-info': !envioEmbrapa.enviou}"
                                                @click="enviarEmail(indexEnvioEmbrapa)"
                                                title="Enviar por email">
                                            <i class="fa fa-envelope"></i>
                                        </button> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <vc-paginacao :source="pagination" @navigate="navigate"></vc-paginacao>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    table th {
        font-size: 15px !important;
    }

    table td {
        font-size: 13px !important;
    }

    table.dataTable thead th,
    table.dataTable thead td {
        padding: 10px 18px;
        border-bottom: 1px solid #111;
    }

    @media screen and (max-width: 584px) {
        table th:nth-child(2) {
            display: none;
        }

        table td:nth-child(2) {
            display: none;
        }
    }

    @media screen and (max-width: 445px) {
        table th:nth-child(3) {
            display: none;
        }

        table td:nth-child(3) {
            display: none;
        }
    }

    @media screen and (max-width: 600px) {
        table th:nth-child(6) {
            display: none;
        }

        table td:nth-child(6) {
            display: none;
        }
    }

    @media screen and (max-width: 600px) {
        table th:nth-child(4) {
            display: none;
        }

        table td:nth-child(4) {
            display: none;
        }
    }

    @media screen and (max-width: 400px) {
        table th:nth-child(7) {
            display: none;
        }

        table td:nth-child(7) {
            display: none;
        }
    }

    .lista-analises button {
        margin-left: 5px;
    }

    .nav-tabs > li.active > a {
        font-weight: bold;
    }

    .clickable {
        cursor: pointer;
    }

    .table-striped > tbody > tr:nth-of-type(odd) {
        background-color: #ebeef2;
    }
</style>
